import { Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";

const RedAsterisk = (props) => {
  const colors = useColors();

  return (
    <Typography
      variant="caption"
      {...props}
      style={{ color: colors.error_500, ...props.style }}
    >
      *
    </Typography>
  );
};

export default RedAsterisk;
